/**
 * Task Pane JavaScript
 */

Office.onReady((info) => {
    if (info.host === Office.HostType.Excel) {
        console.log('[TaskPane] Office.js ready');
        updateStatus();

        // Update status every 2 seconds
        setInterval(updateStatus, 2000);
    }
});

async function updateStatus() {
    // In a real implementation, you'd check actual websocket status
    // For now, we'll show a static status
    const statusEl = document.getElementById('wsStatus');
    const statsEl = document.getElementById('stats');

    statusEl.textContent = 'WebSocket: Ready (simulated)';
    statusEl.className = 'status connected';

    // Show some mock stats
    statsEl.innerHTML = `
        <strong>Stats:</strong><br>
        Queue size: 0<br>
        Pending requests: 0<br>
        Active streams: 0
    `;
}

window.testConnection = async function() {
    console.log('[TaskPane] Testing connection...');
    showMessage('Connection test: OK\n\nThe plugin is ready to use!\n\nTry typing: =ALLOCATOR.TEST(5)', 'success');
}

window.insertTestFormula = async function() {
    try {
        await Excel.run(async (context) => {
            const sheet = context.workbook.worksheets.getActiveWorksheet();
            const range = sheet.getRange("A1");
            range.values = [["=ALLOCATOR.TEST(5)"]];
            range.format.autofitColumns();
            await context.sync();

            console.log('[TaskPane] Inserted test formula');
        });
    } catch (error) {
        console.error('[TaskPane] Error inserting formula:', error);
        showMessage('Error: ' + error.message, 'error');
    }
}

window.clearStats = function() {
    console.log('[TaskPane] Stats cleared');
    document.getElementById('stats').innerHTML = '<em>Stats cleared</em>';
}

// Helper function to show messages in the task pane instead of alert()
function showMessage(message, type = 'info') {
    const messageDiv = document.createElement('div');
    messageDiv.className = `message message-${type}`;
    messageDiv.style.cssText = `
        padding: 12px;
        margin: 10px 0;
        border-radius: 4px;
        background-color: ${type === 'error' ? '#fee' : '#efe'};
        border: 1px solid ${type === 'error' ? '#fcc' : '#cfc'};
        color: ${type === 'error' ? '#c00' : '#060'};
        white-space: pre-line;
    `;
    messageDiv.textContent = message;

    // Insert at the top of the content
    const container = document.querySelector('.content') || document.body;
    container.insertBefore(messageDiv, container.firstChild);

    // Auto-remove after 5 seconds
    setTimeout(() => messageDiv.remove(), 5000);
}
